<ng-container *ngIf="showSideNav">
  <div class="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
    <ul
      nz-menu
      [nzMode]="isCollapsed ? 'vertical' : 'inline'"
      nzTheme="light"
      [nzInlineCollapsed]="isCollapsed"
      (nzCollapsedChange)="collapse($event)"
      class="border-none"
    >
      <ng-container [ngSwitch]="customerType">
        <!-- ENERGY -->
        <li
          nz-menu-item
          [nzSelected]="routeIsActive('/energy/overview')"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Overview' : ''"
          [attr.data-intercom-target]="intercomTarget + '-asset-dashboard-solution'"
        >
          <a
            class="overwrite-link-styling flex items-center gap-8 mr-24"
            [routerLink]="'/energy/overview'"
            (click)="preventDefault($event)"
          >
            <twaice-fe-svg-icon name="home" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }">Overview</span>
          </a>
        </li>

        <li
          nz-menu-item
          [nzSelected]="routeIsActive('/storage-overview')"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Storage Overview' : ''"
          [attr.data-intercom-target]="intercomTarget + '-asset-storage-overview'"
        >
          <a
            class="overwrite-link-styling flex items-center gap-8 mr-24"
            [twRouterLink]="'/storage-overview'"
            (click)="preventDefault($event)"
          >
            <twaice-fe-svg-icon name="layout-dashboard" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }">Dashboards</span>
          </a>
        </li>

        <li
          nz-menu-item
          [nzSelected]="routeIsActive('/storage-hierarchy')"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Hierarchy Diagram' : ''"
          [attr.data-intercom-target]="intercomTarget + '-asset-storage-overview'"
        >
          <a
            class="overwrite-link-styling flex items-center gap-8 mr-24"
            [twRouterLink]="'/storage-hierarchy'"
            (click)="preventDefault($event)"
          >
            <twaice-fe-svg-icon name="tournament" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }">Hierarchy Diagram</span>
          </a>
        </li>

        <li
          *twPackageFeature="[PackageFeature.RecoverableEnergy, PackageFeature.Performance]"
          [attr.data-intercom-target]="intercomTarget + '-performance-manager-solution'"
          [nzTitle]="performanceManagerTitleTpl"
          nz-submenu
          nzOpen
          [nzSelected]="false"
          [attr.data-testid]="'performance-section-selector'"
        >
          <ul>
            <li
              *twPackageFeature="PackageFeature.RecoverableEnergy"
              nz-menu-item
              [nzSelected]="routeIsActive('/performance-manager/availability')"
              [attr.data-intercom-target]="intercomTarget + '-availability-solution'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/performance-manager/availability'"
                (click)="preventDefault($event)"
              >
                Recoverable Energy
              </a>
            </li>

            <li
              *twPackageFeature="PackageFeature.Performance"
              nz-menu-item
              [nzSelected]="routeIsActive('/performance-manager/balancing')"
              [attr.data-intercom-target]="intercomTarget + 'balancing-solution'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/performance-manager/balancing'"
                (click)="preventDefault($event)"
              >
                Imbalances
              </a>
            </li>

            <li
              *twPackageFeature="PackageFeature.Performance"
              nz-menu-item
              [nzSelected]="routeIsActive('/performance-manager/temperature')"
              [attr.data-intercom-target]="intercomTarget + 'temperature-solution'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/performance-manager/temperature'"
                (click)="preventDefault($event)"
              >
                Temperature
              </a>
            </li>
          </ul>
        </li>

        <ng-template #performanceManagerTitleTpl>
          <span class="overwrite-link-styling flex items-center gap-8">
            <twaice-fe-svg-icon name="chart-arrows-vertical" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }" class="mr-32">Performance</span>
          </span>
        </ng-template>

        <li
          [attr.data-intercom-target]="intercomTarget + '-asset-management'"
          [nzTitle]="assetManagementTitleTpl"
          nz-submenu
          nzOpen
          [nzSelected]="false"
        >
          <ul>
            <li
              nz-menu-item
              [nzSelected]="routeIsActive('/warranty-tracker')"
              [attr.data-intercom-target]="intercomTarget + '-warranty-tracker-solution'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/warranty-tracker'"
                (click)="preventDefault($event)"
              >
                <span>Warranty</span>
              </a>
            </li>

            <ng-container *twPackageFeature="PackageFeature.PenaltyRisk">
              <li
                *featureToggle="'!HIDE_PENALTY_RISK'"
                nz-menu-item
                [nzSelected]="routeIsActive('/penalty-risk')"
                [attr.data-intercom-target]="intercomTarget + '-penalty-risk'"
              >
                <a
                  class="overwrite-link-styling flex items-center gap-8"
                  [twRouterLink]="'/penalty-risk'"
                  (click)="preventDefault($event)"
                >
                  <span>Penalty Risk</span>
                </a>
              </li>
            </ng-container>

            <li
              *twPackageFeature="PackageFeature.Degradation"
              nz-menu-item
              [nzSelected]="routeIsActive('/energy/health')"
              [attr.data-intercom-target]="intercomTarget + '-health-solution'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8 h-40"
                [twRouterLink]="'/energy/health'"
                (click)="preventDefault($event)"
              >
                <span>Degradation</span>
              </a>
            </li>

            <li
              nz-menu-item
              [nzSelected]="routeIsActive('/reports')"
              [attr.data-intercom-target]="intercomTarget + '-reports-solution'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8 h-40"
                [twRouterLink]="'/reports'"
                (click)="preventDefault($event)"
              >
                <span>Reports</span>
              </a>
            </li>
          </ul>
        </li>

        <ng-template #assetManagementTitleTpl>
          <span class="overwrite-link-styling flex items-center gap-8">
            <twaice-fe-svg-icon name="icon_warranty" width="16px" height="16px" class="scale-x-[-1]"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }" class="mr-32">Asset Management</span>
          </span>
        </ng-template>

        <li
          *featureToggle="FeatureFlagsEnum.ENABLE_INSIGHTS_AND_ACTIONS"
          [attr.data-intercom-target]="intercomTarget + '-insights-actions'"
          [nzTitle]="insightsActionsTitleTpl"
          nz-submenu
          nzOpen
          [nzSelected]="false"
        >
          <ul>
            <li nz-menu-item [nzSelected]="routeIsActive('/events')" [attr.data-intercom-target]="intercomTarget + '-events'">
              <a class="overwrite-link-styling flex items-center gap-8" [routerLink]="'/events'" (click)="preventDefault($event)">
                <span>Events</span>
              </a>
            </li>
          </ul>
        </li>

        <ng-template #insightsActionsTitleTpl>
          <span class="overwrite-link-styling flex items-center gap-8">
            <twaice-fe-svg-icon name="list-check" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }" class="mr-32">Insights & Action</span>
          </span>
        </ng-template>

        <li
          [attr.data-intercom-target]="intercomTarget + '-monitoring-solution'"
          [nzTitle]="operationsTitleTpl"
          nz-submenu
          nzOpen
          [nzSelected]="false"
        >
          <ul>
            <li
              *twPackageFeature="PackageFeature.Anomalies"
              nz-menu-item
              [nzSelected]="routeIsActive('/safety')"
              [attr.data-intercom-target]="intercomTarget + '-safety-v2'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/safety'"
                (click)="preventDefault($event)"
              >
                <span>Anomalies</span>
              </a>
            </li>

            <li nz-menu-item [nzSelected]="routeIsActive('/alerts')" [attr.data-intercom-target]="intercomTarget + '-alerts'">
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/alerts'"
                (click)="preventDefault($event)"
              >
                <span>Smart Alerts</span>
              </a>
            </li>

            <li
              *twPackageFeature="PackageFeature.ErrorCodes"
              nz-menu-item
              [nzSelected]="routeIsActive('/bms-alerts')"
              [attr.data-intercom-target]="intercomTarget + '-alerts'"
            >
              <a
                class="overwrite-link-styling flex items-center gap-8"
                [twRouterLink]="'/bms-alerts'"
                (click)="preventDefault($event)"
              >
                <span>Error Codes</span>
              </a>
            </li>
          </ul>
        </li>

        <ng-template #operationsTitleTpl>
          <span class="overwrite-link-styling flex items-center gap-8">
            <twaice-fe-svg-icon nz-icon name="icon_health" width="16px" height="16px" class="scale-x-[-1]"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }" class="mr-32">Operations & Safety</span>
          </span>
        </ng-template>

        <li
          nz-menu-item
          [nzSelected]="routeIsActive('/data-explorer')"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Data Explorer' : ''"
          [attr.data-intercom-target]="intercomTarget + '-data-explorer-solution'"
        >
          <a
            class="overwrite-link-styling flex items-center gap-8"
            [twRouterLink]="'/data-explorer/views'"
            (click)="preventDefault($event)"
          >
            <twaice-fe-svg-icon name="icon_data_explorer" width="16px" height="16px"></twaice-fe-svg-icon>
            <span [ngClass]="{ invisible: isCollapsed }">Data Explorer</span>
          </a>
        </li>

        <!-- MOBILITY -->
        <ng-container *ngSwitchCase="CustomerType.MOBILITY">
          <li
            nz-menu-item
            [nzSelected]="routeIsActive('/mobility-explore/overview')"
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isCollapsed ? ('Home' | translate: { _key: 'fleet.nav.home' }) : ''"
            [attr.data-intercom-target]="intercomTarget + '-mobility-home'"
          >
            <a class="overwrite-link-styling flex items-center gap-8" [routerLink]="'/mobility-explore/overview'">
              <twaice-fe-svg-icon name="home" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
              <span [ngClass]="{ invisible: isCollapsed }">{{ 'Home' | translate: { _key: 'fleet.nav.home' } }}</span>
            </a>
          </li>

          <li
            nz-menu-item
            [nzSelected]="isPartOfExploreAndCompare"
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isCollapsed ? ('Explore & Compare' | translate: { _key: 'fleet.nav.explore' }) : ''"
            [attr.data-intercom-target]="intercomTarget + '-mobility-explore-compare-solution'"
          >
            <a class="overwrite-link-styling flex items-center gap-8" [routerLink]="'/mobility-explore/table'">
              <twaice-fe-svg-icon name="directions" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
              <span [ngClass]="{ invisible: isCollapsed }">{{
                'Explore & Compare' | translate: { _key: 'fleet.nav.explore' }
              }}</span>
            </a>
          </li>

          <li
            nz-menu-item
            [nzSelected]="routeIsActive('/reporting/library')"
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isCollapsed ? ('Reports' | translate: { _key: 'fleet.nav.reports' }) : ''"
            [attr.data-intercom-target]="intercomTarget + '-mobility-reports-solution'"
          >
            <a class="overwrite-link-styling flex items-center gap-8" [routerLink]="'/reporting/library'">
              <twaice-fe-svg-icon name="file-analytics" source="tabler" width="16px" height="16px"></twaice-fe-svg-icon>
              <span [ngClass]="{ invisible: isCollapsed }">{{ 'Reports' | translate: { _key: 'fleet.nav.reports' } }}</span>
            </a>
          </li>

          <li
            nz-menu-item
            [nzSelected]="routeIsActive('/mobility/config')"
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isCollapsed ? ('Configuration' | translate: { _key: 'fleet.nav.config' }) : ''"
            [attr.data-intercom-target]="intercomTarget + '-mobility-configuration-solution'"
          >
            <a class="overwrite-link-styling flex items-center gap-8" [routerLink]="'/mobility/config'">
              <twaice-fe-svg-icon name="icon_tool" width="16px" height="16px"></twaice-fe-svg-icon>
              <span [ngClass]="{ invisible: isCollapsed }" class="mr-24">
                {{ 'Configuration' | translate: { _key: 'fleet.nav.config' } }}
              </span>
            </a>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </div>

  <div
    nz-tooltip
    nzTooltipPlacement="right"
    [nzTooltipTitle]="isCollapsed ? ('Expand' | translate: { _key: 'fleet.nav.expand' }) : ''"
    class="font-normal text-sm leading-base shrink-0 border-solid border-t-1 border-slate-500 py-13"
    [ngClass]="{ 'flex items-center pl-24': !isCollapsed }"
    [attr.data-intercom-target]="intercomTarget + '-collapse-sidebar-button'"
  >
    <a class="overwrite-link-styling flex items-center justify-center gap-8" (click)="collapse(!isCollapsed)">
      <twaice-fe-svg-icon
        [name]="isCollapsed ? 'layout-sidebar-right-collapse' : 'layout-sidebar-left-collapse'"
        source="tabler"
        width="16px"
        height="16px"
      ></twaice-fe-svg-icon>
      @if (!isCollapsed) {
        <span>{{ 'Collapse' | translate: { _key: 'fleet.nav.collapse' } }}</span>
      }
    </a>
  </div>
</ng-container>
